import React from 'react';
export function HeroSection() {
  return <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden" data-id="element-138">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/4jmG5nr6j1U3Bar2ezcCkj/676d82ed848816903d4d4c1c_AGADIR-7-3.png")'
    }} data-id="element-139" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-[rgba(0,0,0,0.15)] to-[rgba(10,20,50,0.55)]" data-id="element-140" />

      {/* Content */}
      <div className="container relative z-20 mx-auto px-4 md:px-8 h-full flex flex-col justify-center items-end pb-[80px]" data-id="element-141">
        <div className="max-w-2xl text-right" data-id="element-142">
          <h1 className="text-[40px] md:text-[70px] font-[600] text-white leading-[1.1] md:leading-[70px] mb-6 whitespace-pre-line" data-id="element-143">
            {"Adhérer à\nl'ARIH Agadir\nSouss Massa"}
          </h1>
          <p className="text-[18px] md:text-[20px] text-white leading-[32px] opacity-90 ml-auto max-w-lg whitespace-pre-line" data-id="element-144">
            {"Boostez votre visibilité, élargissez votre réseau professionnel\net profitez d'une palette de services exclusifs."}
          </p>
        </div>
      </div>
    </section>;
}